import notifyUser from "@/helpers/notifyUser.js";

// `silent` is for a caller that reports the failure itself (SignForm's inline alert), where
// the toast would only say the same thing twice. Off by default: OrganizationForm has no catch
// of its own, so the toast is the only report it gets.
export default async function validateAndCreateHash(unencryptedMessage, {silent = false} = {}) {
    const { createHash } = window.cryptoPro;

    try {
        if (ArrayBuffer.isView(unencryptedMessage) || unencryptedMessage instanceof ArrayBuffer || typeof unencryptedMessage === "string") {
            return await createHash(unencryptedMessage);
        }
        return await createHash(String(unencryptedMessage));
    } catch (error) {
        // crypto-pro-js swallows any native plugin message that isn't written in Cyrillic
        // (_extractMeaningfulErrorMessage in the vendored lib returns null for it, and every
        // call site discards the original error with no `cause`) and falls back to a generic
        // Russian phrase. So error.message here is already the most specific thing left to us
        // — losing it too, as this used to, leaves both the visitor and support with nothing.
        console.error(error);
        if (silent) {
            throw error;
        }
        notifyUser(error?.message
            ? `Произошла ошибка при подписании, пожалуйста, обратитесь в поддержку (${error.message.replace(/\.+$/, '')})`
            : 'Произошла ошибка при подписании, пожалуйста, обратитесь в поддержку');
        throw error;
    }
}
